import { Typography } from "PFComponents/typography";
import { CustomValue } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { CircleCounter } from "./components/circle_counter";
import { Section } from "./components/section";
import css from "./skills_management_side_panel.module.scss";

type SkillsFrameworksSectionProps = {
  skill: CustomValue;
};

export const SkillsFrameworksSection = ({ skill }: SkillsFrameworksSectionProps): JSX.Element => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "sidePanel" });

  const skillsFrameworks = skill.skillsFrameworks || [];

  return (
    <Section>
      <div className={css.skillsFrameworksWrapper}>
        <span className={css.header}>
          <Typography variant="h4" noMargin>
            {t("skillsFrameworks")}
          </Typography>
          <CircleCounter value={skillsFrameworks.length} />
        </span>
        {!!skillsFrameworks.length && (
          <div className={css.inline}>
            {skillsFrameworks.map(({ id, name }) => (
              <span className={css.withComma} key={id}>
                <Link to="/admin/skills_frameworks">
                  <Typography variant="bodyBold" className={css.inline} noMargin>
                    {name}
                  </Typography>
                </Link>
              </span>
            ))}
          </div>
        )}
      </div>
    </Section>
  );
};
